var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMuffinLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 544.857,
    height: 544.855,
    viewBox: "0 0 544.857 544.855",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_1137",
    x: 0,
    y: 0,
    width: 544.857,
    height: 544.855,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.294
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1457",
    "data-name": "Group 1457",
    transform: "translate(-2000.143 -7.307)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1456",
    "data-name": "Group 1456",
    transform: "translate(6393.499 20104.244)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4393.36, -20096.94)",
    filter: "url(#Path_1137)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1137-2",
    "data-name": "Path 1137",
    d: "M118.91,0H365.947a118.91,118.91,0,0,1,118.91,118.909V365.946A118.91,118.91,0,0,1,365.948,484.855H118.91A118.91,118.91,0,0,1,0,365.946V118.909A118.91,118.91,0,0,1,118.909,0Z",
    transform: "translate(30 28)",
    fill: "#f04417"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path725",
    d: "M108,.424,360,169c23.236,3.483,37.866,28.837,34.7,51A46.505,46.505,0,0,1,372,253.662c-4.965,2.83-15.554,3.493-18.431,8.485-4.083,7.085-5.2,17.054-7.594,24.853-6.333,20.6-13.5,49.433-19.919,70-7.453,30.758-26.787,30.816-26.787,30.816s-79.683,3.356-107.269,0c-15.832-1.927-22.968-17.436-27.33-30.816-9.841-30.188-15.137-62.273-26.3-91.981-2.678-7.124-11.22-5.754-17.367-7.768A45.4,45.4,0,0,1,98.785,241C71.276,202.979,110.143,158.238,152,170c.5-23.447,22.349-41.508,45-41.946,9.273-.179,17.632,3.513,26,6.946,14.779-40.306,71.65-47.657,104-26.91C348.354,121.786,358.073,144.585,360,169Z",
    transform: "translate(2031.286 34.883)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuffinLogo);
export default __webpack_public_path__ + "static/media/MuffinLogo.91aa03ea4c3c02b352a01f142c602589.svg";
export { ForwardRef as ReactComponent };